<template>
  <div class="wrapper scroll-container-inside">
    <div
      class="scroll-area-inside"
      v-for="(conclusion, i) in conclusions"
      :key="i"
      :id="i"
      v-observe-visibility="{
        callback: visibilityChanged,
        intersection: {
          threshold: 0.3,
        },
      }"
    >
      <ContentWrapper :id="`section-1-${i + 1}`">
        <ConclusionItem :conclusion="conclusion" />
      </ContentWrapper>
    </div>
    <div
      class="scroll-area-inside"
      v-observe-visibility="{
        callback: sotVisibilityChanged,
        intersection: {
          threshold: 0.3,
        },
      }"
    >
      <ContentWrapper nowSection="2" :id="`section-2-1`">
        <Sot :sot="sot" />
      </ContentWrapper>
    </div>
    <div
      v-observe-visibility="{
        callback: feedbackVisibilityChanged,
      }"
    >
      <div
        class="scroll-area-inside"
        v-for="(feedback, feedbackIndex) in feedbacks"
        :key="feedback.name"
        :id="
          feedbackIndex === 0 ? `section-2-2` : `section-2-2-${feedbackIndex}`
        "
      >
        <ContentWrapper nowSection="2">
          <FeedbackItem :feedback="feedback" :index="feedbackIndex" />
        </ContentWrapper>
      </div>
    </div>
    <div
      class="scroll-area-inside action"
      v-observe-visibility="{
        callback: actionVisibilityChanged,
        intersection: {
          threshold: [0.7],
        },
      }"
      id="section-2-3"
    >
      <div class="action__thumb">
        <img src="../assets/thumb2.svg" />
      </div>
      <ContentWrapper :isGreen="true">
        <div class="action__content">
          <Action v-if="false" :action="action" />
          <ActionTwo :action="actionTwo" />
        </div>
      </ContentWrapper>
    </div>
  </div>
</template>

<script>
import ContentWrapper from './ContentWrapper.vue';
import ConclusionItem from './ConclusionItem.vue';
import Sot from './Sot.vue';
import FeedbackItem from './FeedbackItem.vue';
import Action from './Action.vue';
import ActionTwo from './ActionTwo.vue';

export default {
  name: 'MainContent',
  components: {
    ConclusionItem,
    Sot,
    FeedbackItem,
    Action,
    ContentWrapper,
    ActionTwo,
  },
  data() {
    return {
      isStepTwo: false,
    };
  },
  props: {
    conclusions: {
      type: Array,
      default: () => [],
    },
    sot: {
      type: Object,
      default: () => ({}),
    },
    feedbacks: {
      type: Array,
      default: () => [],
    },
    action: {
      type: Object,
      default: () => ({}),
    },
    actionTwo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        this.$emit('setNowSection', [1, parseInt(entry.target.id) + 1]);
      }
    },
    sotVisibilityChanged(isVisible) {
      if (isVisible) {
        this.$emit('setNowSection', [2, 1]);
      }
    },
    feedbackVisibilityChanged(isVisible) {
      if (isVisible) {
        this.$emit('setNowSection', [2, 2]);
      }
    },
    actionVisibilityChanged(isVisible) {
      if (isVisible) {
        this.$emit('setNowSection', [2, 3]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .scroll-container-inside,
  .scroll-area-inside {
    max-width: 100vw;
  }

  .scroll-container-inside {
    overflow: auto;
    scroll-snap-type: y mandatory;
  }

  .scroll-area-inside {
    width: 100vw;
    scroll-snap-align: start;
  }
}

.action {
  position: relative;
  margin-top: 60px;
  // &__content {
  //   max-height: calc(100vh - 85px);
  //   overflow: hidden;
  //   &.scroll {
  //     overflow: scroll;
  //   }
  //   @media (min-width: 768px) {
  //     max-height: calc(100vh - 75px);
  //   }
  // }
  &__thumb {
    width: 80px;
    height: 80px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #77bc1f;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    img {
      width: 60%;
    }
    @media (min-width: 768px) {
      left: calc(172px + 50vw);
      width: 120px;
      height: 120px;
    }
  }
}
</style>
